import { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../state/store";
import { getComparisonMode } from "../utils";
import type { ComparisonMode } from "../types";

export const useComparisonMode = (): ComparisonMode | null => {
  const { dates: dateFilters, timeRange: timeFilters } = useSelector(
    (state: RootState) => state.filters
  );
  const [startDate, endDate] = dateFilters;
  const [startTime, endTime] = timeFilters;

  return useMemo(() => {
    if (!startDate || !endDate) return null;
    return getComparisonMode({ startDate, endDate, startTime, endTime });
  }, [startDate, endDate, JSON.stringify(startTime), JSON.stringify(endTime)]);
};
